import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import CreateViewEditDropList from "./create-view-edit-droplist";
import InnerLayout from "../../../components/layouts/inner-layout";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import errorToast from "../../../components/helper-components/error-toast";
import { viewDropListItemsAction } from "../../../redux/actions/purchase-action";

const ViewDropList = () => {
  const { dropListId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [dropListHeader, setDropListHeader] = useState({});
  const [vendorDetails, setVendorDetails] = useState([]);
  const [items, setItems] = useState([]);

  useEffect(() => {
    dispatch(viewDropListItemsAction(dropListId, onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setDropListHeader(data?.data?.dropListHeader ?? {});
    setVendorDetails(data?.data?.vendorDetails ?? []);
    setItems(data?.data?.itemData ?? []);
    setLoading(false);
  };
  const onError = (err) => {
    setLoading(false);
    navigate(-1);
    errorToast(err?.data?.message || "Failed to load drop list");
  };

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout backBtn={true} title="Drop List">
          <CreateViewEditDropList
            vendorDetails={vendorDetails}
            itemData={items}
            disabled={true}
            page="view"
            standAlone={true}
            pageType="droplist"
            dropListId={dropListId}
            warehouseId={dropListHeader?.warehouse_id}
            initialDropperId={dropListHeader?.dropper_id}
            initialDropperName={dropListHeader?.dropper_name}
            status={dropListHeader?.status}
            created_date={dropListHeader?.created_date ?? ""}
          />
        </InnerLayout>
      )}
    </>
  );
};

export default ViewDropList;
